import type { ThemeConfig } from 'antd';
import {theme} from "antd";

const config: ThemeConfig = {
    algorithm: theme.defaultAlgorithm,
    "token": {
        "colorPrimary": "#ff6645",
        "colorInfo": "#ff6645"
    }
};

export default config;